var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var AuthenticationRepository = /** @class */ (function (_super) {
    __extends(AuthenticationRepository, _super);
    function AuthenticationRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = null;
        _this.baseUrl = ENV.JOBILLA_API_ROOT;
        _this.url = 'auth';
        return _this;
    }
    AuthenticationRepository.prototype.login = function (email, password) {
        return this.post('/oauth/token', {
            username: email,
            password: password,
            client_id: ENV.OAUTH_CLIENT_ID,
            client_secret: ENV.OAUTH_CLIENT_SECRET,
            grant_type: 'password',
        });
    };
    AuthenticationRepository.prototype.loginSocial = function (email, token, provider) {
        return this.post('/api/v2/social-login', {
            username: email,
            token: token,
            provider: provider,
        });
    };
    AuthenticationRepository.prototype.refresh = function (refreshToken) {
        return this.post('/oauth/token', {
            refresh_token: refreshToken,
            client_id: ENV.OAUTH_CLIENT_ID,
            client_secret: ENV.OAUTH_CLIENT_SECRET,
            grant_type: 'refresh_token',
        });
    };
    AuthenticationRepository.prototype.checkAuthState = function () {
        return this.get('/api/v2/auth/check');
    };
    AuthenticationRepository.prototype.logOut = function () {
        return this.post('/api/v2/auth/logout');
    };
    AuthenticationRepository.prototype.requestReset = function (email) {
        return this.post('/api/v2/user/password-reset', { email: email });
    };
    AuthenticationRepository.prototype.updatePassword = function (credentials) {
        return this.post('password/reset', credentials);
    };
    AuthenticationRepository.prototype.getPermissions = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/api/v2/user/permissions')];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    AuthenticationRepository.prototype.checkResetTokenValidity = function (email, token) {
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.get("password/reset/" + email + "/" + token)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AuthenticationRepository;
}(AbstractRepository));
export { AuthenticationRepository };
